<template lang="pug">
.task-coupon-container(:style="{paddingBottom: showMore ? '0.15rem' : ''}" v-platform-expose="moduleExpose")
  template(v-if="tasks && tasks.length > 0")
    .tasks
      .task-expose-wrapper(
        v-for="(item, index) in tasks"
        :key="item.taskCode"
        v-platform-expose="{ handler: taskExpose, data: { item, index } }"
      )
        //- 多单任务运营方案场景
        .task-row(
          v-if="item.marketPlan === 'pp_multi_task'"
          :key="'multi-' + item.taskCode"
        )
          MarketingTask(
            :moduleData="{ taskCouponList: [item] }"
            :inline="true"
            @expired="handleMultiOrderExpired"
          )
        //- 游戏任务场景
        .task-row(
          v-else-if="item.taskType === 'game'"
          :key="'game-' + item.taskCode"
        )
          GameTaskCard(
            :moduleData="item"
            :doubleInformation="doubleInformation"
          )
        //- 吃饭睡觉补贴任务
        SubsidyTask(
          v-else-if="item.taskType === 'meal_subsidy'"
          :key="'subsidy-' + item.taskCode"
          :item="item"
          @click="handleClickTask(item, index)"
          @countdown-end="$emit('refreshTasks')"
        )
        //- 返佣任务
        TaskFakeback.task-item(
          v-else-if="isFackBackTask(item.marketPlan)"
          :key="'fakeback-' + item.taskCode"
          :item="item"
          :index="index"
        )
        //- 阶梯视频任务
        .task-row(
          v-else-if="item.marketPlan === 'incentive_video_scheme'"
          :key="'tiered-' + item.taskCode"
        )
          TieredVideoTask(
            :taskItem="item"
            :doubleInformation="doubleInformation"
            :index="index"
            @completed="$emit('refreshTasks')"
            @adLoadFailed="$emit('refreshTasks', { degradeTaskCode: item.taskCode })"
          )
        //- 优量汇广告任务
        template(v-else-if="item.marketPlan === MARKET_PLAN.GDT_TASK")
          .task-row(
            v-if="!hiddenGdtTasks[item.taskCode]"
            :key="'gdt-' + item.taskCode"
          )
            GdtTaskCard(
              :task="item"
              :index="index"
              :doubleInformation="doubleInformation"
              @gdt-change="(hidden) => handleGdtVisibilityChange(item.taskCode, hidden)"
            )
        //- 常规任务
        .task-item(
          v-else
          :key="item.taskCode"
          :class="{ 'task-item-surprised': item.isHighlight }"
          @click="handleClickTask(item, index)"
        )
          .task-left
            .left
              .icon-new-block
                SafeImg(class-name="left-logo" :src="item.taskImgUrl")
            .mid
              .title {{ item.title }}
              .progress
                .progress-right(v-if="item.amount")
                  img.progress-right-img(:src="coinIcon")
                  .progress-right-text +{{ item.amount }}
                //- 推荐系统角标+文案。优先级高于副标题
                .coupon-badge(v-if="item.couponInfo && item.couponInfo.prizeDesc")
                  .coupon-icon
                    img(:src="item.couponInfo.icon")
                  .coupon-text {{ item.couponInfo.prizeDesc }}
                .progress-left(v-else) {{ item.additionalDesc }}

          .right
            .btn(
              :class="{\
                'to-accept': item.status === TaskStatus.TO_ACCEPT,\
                doing: item.status === TaskStatus.DOING,\
                'can-done': item.status === TaskStatus.CAN_DONE,\
                done: item.status === TaskStatus.DONE \
              }"
            ) {{ item.buttonName }}
    .tasks-line(v-if="totalTaskCount > 3 && !showMore")
    .more(
      v-if="!preparing && totalTaskCount > 3 && !showMore"
      @click="seeMore"
    )
      template(v-if="!showMore")
        span 还有{{ taskNum }}个任务
        .common-arrow-down
      template(v-else)
        span 收起
        .common-arrow-up
  template(v-else)
    Empty
</template>


<script>
import { Native, env } from '@hb/NBridge/lib/h5';
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import Empty from '@/components/empty';
import Toast from '@/components/toast';
import SafeImg from '@/components/safe-img';
import {
  getTokenAndKey,
  getCityInfo,
  getTokenAndLocation,
} from '@/utils/index';
import { mapTaskV2, mapBusinessInfo } from '@/utils/mappers';
import { TaskStatus } from '@/const/task';
import {
  acceptTaskV2,
  getTaskAward,
  receiveActivityCoupon,
} from '@/api/bounty';
import { getTaskActivity } from '@/api/fuli';
import { getVersion, getSystemCode } from '@/utils/systemCode';
import { jumpEvent } from '@/api/lottery';
import eventBus from '@/const/eventBus';
import { ParamsUtil } from '@/utils/params';
import {
  jumpUrl,
  compareVersions,
  checkWXInstallation,
  generateUUID,
} from '@/utils/tools';
import MarketingTask from './marketing-task';
import GameTaskCard from './game-task-card';
import TaskFakeback from './task-fakeback';
import TieredVideoTask from './tiered-video-task.vue';
import GdtTaskCard from './gdt-task-card.vue';
import SubsidyTask from './subsidy-task.vue';
import SPM from '../../common/spm';
import {
  pushNotificationEnabled,
  openSystemSettingPage,
  mobileAdReplacementWithLink,
  openDeepLinkWithParams,
  platformOpenScheme,
  addWidget,
} from '../../common/bridge';
import {
  pushTaskFinished, requestTaskMonitoring,
  queryUserWidgetStatus, isFackBackTask,
} from '../../common/helper';
import {
  TrueJumpCrossTasks,
  ORDER_JUMP_CROSS,
  JUMP_TO_WX_RENT,
  WeiboBrowse,
  WhiteList,
  SYSTEM_SETTING_TASKS,
  MARKET_PLAN,
  TASK_SPM_INFO_MAP,
  WIDGET_TEMPLATE_ID,
  WIDGET_SOURCE,
} from '../../consts';
import { handleTaskBtnClick, handleMultiTraceTask, loadTaskAwardPopup } from '../../common/task';

export default {
  name: 'TaskList',
  components: {
    Empty,
    SafeImg,
    MarketingTask,
    GameTaskCard,
    TaskFakeback,
    TieredVideoTask,
    GdtTaskCard,
    SubsidyTask,
  },
  props: {
    newModule: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    preparing: {
      type: Boolean,
      default: true,
    },
    doubleInformation: {
      type: Object,
      default: () => ({}),
    },
    moduleKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      TaskStatus,
      btnText: {
        [TaskStatus.TO_ACCEPT]: '领任务',
        [TaskStatus.DOING]: '去完成',
        [TaskStatus.CAN_DONE]: '领奖励',
      },
      showMore: false,
      isMP: false,
      jumpTimer: null,
      rankedActivityList: [],
      doubleInformationHistory: null,
      hiddenGdtTasks: {},
      MARKET_PLAN,
    };
  },
  inject: ['isSupportAd', 'getStyleVersion'],
  computed: {
    coinIcon() {
      return 'https://m.hellobike.com/fd018348_new_coin.png';
    },
    tasks() {
      if (this.preparing) {
        return [{ shadow: true }, { shadow: true }, { shadow: true }];
      }
      if (!this.data || this.data.length === 0) {
        return [];
      }
      if (this.data.length <= 3 || this.showMore) {
        return this.data;
      }
      return this.data.slice(0, 3);
    },
    // 总任务数
    totalTaskCount() {
      return this.data ? this.data.length : 0;
    },
    taskNum() {
      if (this.totalTaskCount > 3) {
        return this.totalTaskCount - 3;
      }
      return 0;
    },
  },
  watch: {
    tasks(v) {
      if (v && v.length > 0) {
        const taskCodes = v.map((item) => item.taskCode);
        if (taskCodes && taskCodes.length) {
          // this.getActivity(taskCodes);
        }
      }
    },
    doubleInformation: {
      handler(newVal) {
        // 由于用完后要置空 所以保存在data中
        this.doubleInformationHistory = { ...newVal };
      },
      deep: true,
    },
  },
  mounted() {
    if (env.isAliMP || env.isAliMPMonitor) {
      this.isMP = true;
    }
    this.clearnTimeOut();
  },
  beforeDestroy() {
    this.jumpTimer = null;
  },
  methods: {
    moduleExpose() {
      // 任务模块埋点上报
      const spmInfo = TASK_SPM_INFO_MAP[this.moduleKey] || {};
      if (spmInfo.moduleExpose) {
        SPM.moduleExpose({
          moduleId: spmInfo.moduleExpose,
          contentId: spmInfo.moduleExpose,
          businessInfo: {},
        });
      }
    },
    taskExpose(entry, { item, index } = {}) {
      if (!item) {
        return;
      }
      const {
        amount, title, taskCode,
      } = item;
      // 阶梯视频任务计算阶梯序号（当前看的是第几个）
      const stageOffers = item.stageOffers || [];
      const completed = stageOffers.filter((s) => s.offerStatus === 3).length;
      const isTiered = stageOffers.length > 0;
      SPM.moduleExpose({
        moduleId: 'platform_oneTask',
        contentId: 'platform_oneTask',
        exposureTimes: 1,
        businessInfo: {
          bonusAmount: amount,
          taskBonus: amount,
          rankNum: index + 1,
          task_name: title,
          taskid: taskCode,
          ...(isTiered ? { ladderIndex: String(completed + 1) } : {}),
        },
      });
    },
    // 外层判断逻辑，APP走clickTaskV2，小程序走新的跳转方式
    async handleClickTask(item, index) {
      // 任务点击埋点上报
      const spmInfo = TASK_SPM_INFO_MAP[this.moduleKey] || {};
      // 根据任务状态计算 buttonState：0-领任务，1-去完成，2-领奖励
      const buttonState = this.getButtonState(item);
      SPM.clickButton({
        buttonName: spmInfo.btnClick,
        businessInfo: {
          task_id: item.taskCode,
          taskBonus: item.amount || '',
          rankNum: index + 1,
          task_name: item.taskName,
          buttonState,
          taskSequence: index,
          isSurpriseTask: item.isHighlight ? '1' : '0',
        },
      });
      if (item.taskType === 'sign_task') {
        eventBus.$emit('showSignInPopup');
        return;
      }
      // 吃饭睡觉补贴任务：无论状态，统一跳转
      if (item.taskType === 'meal_subsidy') {
        const link = (item.btnLink && item.btnLink.app) || item.titleBarUrl;
        if (link) {
          if (env.isEasyBikeApp) {
            jumpUrl(link);
          } else {
            this.handleOtherTask(item);
          }
        }
        return;
      }
      if (env.isEasyBikeApp) {
        this.clickTaskV2(item, index);
      } else {
        const options = { scene: 'task_list', needReceiveCoupon: true };
        handleTaskBtnClick.call(this, item, options);
      }
    },
    // 获取按钮状态：0-领任务，1-去完成，2-领奖励
    getButtonState(item) {
      if (item.shouldAccept) return '0';
      if (item.status === TaskStatus.DOING) return '1';
      if (item.status === TaskStatus.CAN_DONE) return '2';
      return '';
    },
    async getActivity(taskCodes) {
      try {
        const { token, adCode, cityCode } = await getTokenAndLocation();
        const params = {
          token,
          adCode,
          cityCode,
          taskCodes,
        };
        const {
          data: { taskCouponList = [] },
        } = await getTaskActivity(params);
        if (!taskCouponList || !taskCouponList.length) return;
        const rankedActivityList = this.tasks.map((task) => {
          const activity = taskCouponList.find(
            (act) => act.taskCode === task.taskCode,
          );
          if (
            activity
            && activity.couponInfo
            && activity.couponInfo.prizeDesc
          ) {
            const { couponInfo } = activity;
            const subCoupon = {
              ...couponInfo,
            };
            return subCoupon;
          }
          return {};
        });
        this.rankedActivityList = rankedActivityList;
      } catch {
        //
      }
    },
    async receiveActivity(activity) {
      const {
        activityCode, prizeCode, status, eventCode,
      } = activity;
      if (status !== 1) {
        // 活动不是可领状态
        return;
      }
      const { token, adCode, cityCode } = await getTokenAndLocation();
      const param = {
        token,
        adCode,
        cityCode,
        activityCode,
        eventCode,
        param: {
          activityCode,
          prizeCode,
        },
        department: 'platform',
        channelId: env.platformCode,
        // channelId: 4,
      };

      receiveActivityCoupon(param)
        .then(() => {
          this.getActivity();
        })
        .catch(() => {
          Toast.show('领取失败');
        });
    },
    seeMore() {
      const spmInfo = TASK_SPM_INFO_MAP[this.moduleKey] || {};
      SPM.clickButton({
        buttonName: spmInfo.moreBtnClick,
        businessInfo: {},
      });
      // 展开之后不需要收起按钮，会影响屏效
      this.showMore = !this.showMore;
    },
    async clickTaskV2(item, index) {
      if (!item || item.disabled) {
        return;
      }
      if (item.status === TaskStatus.DOING) {
        this.close();
      }

      let UBTButtonName = 'market_task_clickreceive';
      if (item.status === TaskStatus.DOING) {
        UBTButtonName = 'market_task_clicktodo';
      } else if (item.status === TaskStatus.CAN_DONE) {
        UBTButtonName = 'market_task_getrewards';
      }
      UBT.clickButton({
        pageId: 'platform_bounty',
        buttonName: UBTButtonName,
        categoryId: 'platform',
        businessInfo: mapBusinessInfo(item),
      });
      // eslint-disable-next-line no-console
      if (item.shouldAccept) {
        const { token } = await getTokenAndKey();
        UBT.clickButton({
          pageId: 'Welfare',
          buttonName: 'market_task_clickreceive',
          categoryId: 'market',
          businessInfo: mapBusinessInfo(item),
        });
        const { taskGroupCode, taskCode, expertId } = item;
        acceptTaskV2({
          token,
          channelId: env.platformCode,
          sceneNameEn: 'platform_points',
          subSceneNameEn: 'platform_points_pointshp',
          version: await getVersion(),
          ...(await getCityInfo()),
          taskList: [
            {
              taskCode,
              taskGroupCode,
              expertId,
            },
          ],
        })
          .then(async (res) => {
            if (item.couponInfo && item.couponInfo.worth) {
              this.receiveActivity(item.couponInfo);
            }
            if (res && res.data && res.data.taskList && res.data.taskList[0]) {
              const { errorCode } = res.data.taskList[0] || {};
              if (errorCode) return;

              Toast.show('任务领取成功');
              const task = mapTaskV2(res.data.taskList[0]);
              const {
                status,
                process,
                target,
                shouldAccept,
                buttonName,
                end,
              } = task;
              Object.assign(this.data[index], {
                status,
                process,
                target,
                shouldAccept,
                buttonName,
                end,
              });

              // 处理消息推送类任务自动完成
              this.handlePushTaskFinished(item);
              // 领取完成去做任务
              this.handleDoingTask(item);
            } else {
              Toast.show('查询任务信息失败');
              Object.assign(this.data[index], {
                status: TaskStatus.DOING,
                buttonName: this.btnText[TaskStatus.DOING],
                shouldAccept: false,
              });
            }
          })
          .catch((e) => {
            Toast.show(e && e.message ? e.message : '任务领取失败');
          });
      } else {
        if (item.status === TaskStatus.CAN_DONE) {
          const { token } = await getTokenAndKey();
          UBT.clickButton({
            pageId: 'Welfare',
            buttonName: 'market_task_getrewards',
            categoryId: 'market',
            businessInfo: mapBusinessInfo(item),
          });
          const { taskGuid, taskGroupCode } = item;
          getTaskAward({
            token,
            channelId: env.platformCode,
            taskGuid,
            taskGroupCode,
            version: await getVersion(),
          })
            .then(() => {
              Toast.show(`任务奖励领取成功，+${item.amount}奖励金`);
              this.handleLoadTaskAwardPopup({
                rewardCount: item.amount,
                task: item,
                index,
                supportAd: this.isSupportAd(),
              });
              eventBus.$emit('refreshTaskList');
            })
            .catch((e) => {
              Toast.show(`${(e && e.message) || '任务奖励领取失败'}`);
            });
          return;
        }
        if (item.status === TaskStatus.DOING) {
          this.handleDoingTask(item);
        }
      }
    },
    // 处理进行中的任务跳转
    async handleDoingTask(item) {
      UBT.clickButton({
        pageId: 'Welfare',
        buttonName: 'market_task_clicktodo',
        categoryId: 'market',
        businessInfo: mapBusinessInfo(item),
      });

      // 如果是商业化任务 并且是新版本 并且是多链接跳转形式 调用统一bridge处理
      if (item.businessType === 'commercial'
        && await getVersion() >= '6.98.50'
        && item.linkingMode === 3
      ) {
        const { userNewId } = await getTokenAndKey();
        const { app } = item.btnLink;
        const {
          jumpPattern,
          iosAppId = '',
          androidPkgName = '',
          wakePortLink = '',
          link = '',
          userName = '',
          path = '',
          ulk,
          clickTracking = '',
        } = app;
        try {
          Native.callNative({
            classMap: 'hellobike/marketing/openAllAdsURLAndTrack',
            method: 'openAdsUrlWithTracking',
            params: {
              linkType: jumpPattern === 1 ? 'applet' : 'deeplink',
              jumpConfig: {
                iosAppId,
                androidPkgName,
                userName,
                path,
                wakePortLink,
                link,
                ulk,
              },
              trackConfig: {
                userId: userNewId,
                taskCode: item.taskCode,
                trackerUrls: [
                  {
                    trackerUrl: clickTracking,
                    requestType: 'get',
                  },
                ],
              },
              appendConfig: [
                {
                  replaceKey: '__USER_NEW_ID__',
                  appendKey: 'userId',
                  value: userNewId,
                },
                {
                  replaceKey: '__TASK_CODE__',
                  appendKey: 'taskCode',
                  value: item.taskCode,
                },
              ],
              uuid: generateUUID(),
            },
          });
        } catch (e) {
          Toast.show(e && e.message ? e.message : '网络开小差~');
        }
        return;
      }

      // 商业方案为pp_effct_adtask的时候，需要对h5链接的参数做替换和加参处理
      if (item.marketPlan === MARKET_PLAN.PP_EFFECT_ADTASK) {
        const { app } = item.btnLink;
        const { schema, h5 } = app;
        if (h5) {
          const newLink = await this.taskLinkParamsHandle(h5, item);
          await requestTaskMonitoring(newLink, item);
        }
        if (schema) {
          const httpsRegex = /^https?:\/\/\S+/;
          const newLink = await this.taskLinkParamsHandle(schema, item);
          if (httpsRegex.test(schema)) {
            Native.openThirdWeb({ url: newLink });
          } else {
            openDeepLinkWithParams({ wakeLink: newLink });
          }
        }
        return;
      }

      if (item.marketPlan === MARKET_PLAN.PP_WIDGET) {
        // 添加桌面小组件
        await addWidget({ templateId: WIDGET_TEMPLATE_ID, source: WIDGET_SOURCE });
        // 回调后查询小组件状态，已添加则播放金币动效并刷新任务列表
        const { hasAddedComponent } = await queryUserWidgetStatus();
        if (hasAddedComponent) {
          eventBus.$emit('playCollectAnimate');
          eventBus.$emit('refreshTaskList');
        }
        return;
      }

      // 跳转系统设置页
      if (SYSTEM_SETTING_TASKS.includes(item.marketPlan)) {
        openSystemSettingPage();
        return;
      }

      if (item.linkingMode === 3) {
        handleMultiTraceTask(item);
        return;
      }

      const matchPlan = [
        ...TrueJumpCrossTasks,
        ...WeiboBrowse].includes(item.marketPlan);
      if (item.taskActivityType === 1 && !matchPlan) {
        await this.handleActivityTypeOneTask(item);
      } else {
        await this.handleOtherTask(item);
      }
    },
    // 处理 taskActivityType === 1 的任务
    async handleActivityTypeOneTask(item) {
      let channel = 'app';
      if (env.isAliMP || env.isAliMPMonitor) {
        channel = 'ali';
      }
      const data = await getTokenAndLocation();
      const { token, adCode, cityCode } = data;
      try {
        let btnLink = item.btnLink[channel];
        if (ORDER_JUMP_CROSS.includes(item.marketPlan)) {
          btnLink = item.btnLink[channel].schema;
        }
        const res = await jumpEvent({
          token,
          cityCode,
          adCode,
          channelId: env.platformCode,
          systemCode: getSystemCode(),
          version: await getVersion(),
          btnLink,
          taskCode: item.taskCode,
          sceneNameEn: 'weekly_cash',
          subSceneNameEn: 'weekly_cash_app',
          browseDuration: item.browseDuration,
        });
        if (res.success) {
          const link = item.btnLink[channel] || item.titleBarUrl;
          if (channel === 'ali') {
            Native.callNative({
              method: 'goOperationUrlV2',
              params: link,
            });
          } else {
            window.onpageshow = null;
            window.onpageshow = () => {
              window.location.reload();
            };
            if (ORDER_JUMP_CROSS.includes(item.marketPlan)) {
              await this.handleOrderJumpCross(link);
              return;
            }
            // 跳转微信拦截处理
            if (env.isEasyBikeApp && env.isIOS && JUMP_TO_WX_RENT.includes(item.marketPlan)) {
              const isWXInstalled = await checkWXInstallation();
              if (!isWXInstalled) {
                Toast.show('请先安装微信');
                return;
              }
            }
            jumpUrl(link);
          }
        }
      } catch (e) {
        Toast.show(e && e.message ? e.message : '任务领取失败');
      }
    },
    // 处理其他类型任务
    async handleOtherTask(item) {
      let channel = 'app';
      if (env.isAliMP || env.isAliMPMonitor) {
        channel = 'ali';
      }
      const link = item.btnLink[channel] || item.titleBarUrl;
      if (channel === 'ali') {
        Native.callNative({
          method: 'goOperationUrlV2',
          params: link,
        });
      } else if (item.taskActivityType === 8) {
        window.location.href = link;
      } else if (item.marketPlan === 'weibo_browse') {
        Native.openThirdWeb({ url: link });
      } else if (TrueJumpCrossTasks.includes(item.marketPlan)) {
        await this.handleTrueJumpCross(link);
      } else {
        jumpUrl(link);
      }
    },
    // 处理跨端跳转（ORDER_JUMP_CROSS）
    async handleOrderJumpCross(link) {
      if (env.isIOS) {
        if ((await getVersion()) >= '6.72.0') {
          platformOpenScheme(link);
        } else if (
          WhiteList.filter(
            (whiteItem) => link.schema && link.schema.includes(whiteItem),
          ).length > 0
        ) {
          window.location.href = link.schema;
          this.jumpTimer = setTimeout(() => {
            Native.openThirdWeb({ url: link.h5 });
          }, 3000);
        } else {
          Native.openThirdWeb({ url: link.h5 });
        }
      } else if (env.isAndroid) {
        if ((await getVersion()) >= '6.70.0') {
          platformOpenScheme(link);
        } else {
          Native.openThirdWeb({ url: link.h5 });
        }
      }
    },
    // 处理真跨端跳转（TrueJumpCrossTasks）
    async handleTrueJumpCross(link) {
      if (env.isIOS) {
        if ((await getVersion()) >= '6.72.0') {
          platformOpenScheme(link);
        } else if (
          WhiteList.filter(
            (whiteItem) => link.schema && link.schema.includes(whiteItem),
          ).length > 0
        ) {
          window.location.href = link.schema;
          this.jumpTimer = setTimeout(() => {
            Native.openThirdWeb({ url: link.h5 });
          }, 3000);
        } else {
          Native.openThirdWeb({ url: link.h5 });
        }
      } else if (env.isAndroid) {
        if ((await getVersion()) >= '6.70.0') {
          platformOpenScheme(link);
        } else {
          Native.openThirdWeb({ url: link.h5 });
        }
      }
    },
    /**
     * 任务链接参数处理
     * @param {string} link - h5链接
     * @param {object} task - task任务数据
     * @returns {Promise<string>} 处理后的链接
     */
    async taskLinkParamsHandle(link, task) {
      try {
        const res = await mobileAdReplacementWithLink({ link });
        const { userNewId } = await getTokenAndKey();
        const resLink = ParamsUtil.addParams(res.link, {
          userid: userNewId,
          taskCode: task.taskCode,
        }).replace('__REQUESTID__', generateUUID()).replace('__TASK_CODE__', task.taskCode).replace('__USER_NEW_ID__', userNewId);
        return resLink;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('任务链接参数处理失败', error);
        return link;
      }
    },

    // 多单任务过期处理
    handleMultiOrderExpired() {
      this.$emit('refreshTasks');
    },

    close() {
      this.$emit('close');
    },
    clearnTimeOut() {
      const clearnTimeOut = () => {
        if (this.jumpTimer) {
          clearTimeout(this.jumpTimer);
        }
      };
      document.addEventListener('visibilitychange', () => {
        if (document.hidden || document.webkitHidden) {
          clearnTimeOut();
        }
      });
      window.addEventListener('pagehide', () => {
        clearnTimeOut();
      });
    },
    // 处理任务领奖弹窗加载
    handleLoadTaskAwardPopup(options) {
      const {
        rewardCount, task = {}, index = -1, supportAd = false,
      } = options || {};
      loadTaskAwardPopup({
        rewardCount,
        task,
        index,
        doubleInformationHistory: this.doubleInformationHistory || {},
        supportAd,
      });
      this.doubleInformationHistory = null;
    },
    // 处理任务自动完成
    async handlePushTaskFinished(task) {
      const { marketPlan } = task || {};
      const version = await getVersion();

      if (
        marketPlan === 'remind'
        && compareVersions(version, '6.89.5') !== -1
      ) {
        const { enabled = false } = await pushNotificationEnabled();
        if (enabled) {
          const result = await pushTaskFinished(task);
          if (!result.success) return;
          this.$emit('refreshTasks');
        }
      }
    },
    handleGdtVisibilityChange(taskCode, hidden) {
      this.$set(this.hiddenGdtTasks, taskCode, hidden);
    },
    isFackBackTask,
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.task-coupon-container {
  width: 100%;
  padding-bottom: 0.11rem;

  .more {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0.15rem auto 0;
    color: #879099;
    width: 1.43rem;
    height: 0.14rem;
    line-height: 0.14rem;
    font-weight: 400;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-size: 0.12rem;

    .common-arrow-down {
      border-color: #879099;
    }
  }

  .empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 0.12rem;
    color: #ccc;
    padding-bottom: 0.2rem;

    img {
      width: 0.78rem;
      height: 0.68rem;
      margin-bottom: 0.08rem;
    }
  }

  .tasks {
    .task-expose-wrapper {
      position: relative;

      // 底部分隔线，最后一个不显示
      &:not(:last-child)::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0.51rem;
        right: 0.12rem;
        height: 0.01rem;
        background-color: #f6f6f6;
        transform: scaleY(0.5);
      }
    }

    .task-row {
      position: relative;
    }

    .task-item {
      display: flex;
      justify-content: space-between;
      width: 100%;
      max-width: 100%;
      align-items: center;
      position: relative;
      padding: 0.12rem;

      // 每个 item 底部分隔线，最后一个不显示
      &:not(:last-of-type)::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0.51rem;
        right: 0.12rem;
        height: 0.01rem;
        background-color: #f6f6f6;
        transform: scaleY(0.5);
      }

      &.task-item-surprised {
        background: linear-gradient(93.77deg, #fff3b3 0%, #fffdf5 32.24%, #fff 53.49%);
      }

      .task-left {
        display: flex;

        .left {
          margin-right: 0.1rem;

          .icon-new-block {
            overflow: hidden;
            width: 0.4rem;
            height: 0.4rem;
            border-radius: 0.12rem;
          }
        }
      }

      .mid {
        display: flex;
        flex-direction: column;
        flex: 1;
        max-width: 1.9rem;
        overflow: hidden;
        align-items: flex-start;

        .title {
          max-width: 1.9rem;
          font-size: 0.14rem;
          line-height: 0.2rem;
          font-weight: 500;
          color: #242729;
          margin-bottom: 0.02rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .progress {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;

          .progress-left {
            flex: 1;
            min-width: 0;
            color: rgba(90, 96, 102, 0.8);
            font-size: 0.12rem;
            font-family: PingFangSC-Regular, PingFang SC, sans-serif;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .progress-right {
            display: flex;
            align-items: center;
            height: 0.16rem;
            padding-right: 0.08rem;
            border-radius: 0.16rem;
          }

          .progress-right-img {
            width: 0.16rem;
            height: 0.16rem;
          }

          .progress-right-text {
            color: #fe852a;
            font-weight: 600;
            font-size: 0.12rem;
            margin-left: 0.02rem;
          }
        }

        .coupon-badge {
          display: flex;
          align-items: center;
          height: 0.18rem;
          border-radius: 0.06rem;
          overflow: hidden;
          border: 0.01rem solid #ffe3e0;
          background-color: #fff;
          width: fit-content;
          flex-shrink: 0;

          .coupon-icon {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 0.19rem;
            height: 0.18rem;
            background-color: #ffe3e0;
            flex-shrink: 0;

            img {
              width: 0.15rem;
              height: 0.15rem;
            }
          }

          .coupon-text {
            padding: 0 0.04rem;
            font-size: 0.11rem;
            font-weight: 500;
            color: #ff5729;
            line-height: 0.16rem;
            white-space: nowrap;
          }
        }
      }

      .right {
        flex-direction: column;
        align-items: flex-end;
        position: relative;

        .coupon-worth {
          font-family: 'DIN Alternate Bold', sans-serif;
          font-size: 0.11rem;
        }

        .coupon-unit {
          position: relative;
          top: -0.01rem;
        }

        .btn {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 0.62rem;
          height: 0.28rem;
          line-height: normal;
          font-size: 0.12rem;
          font-weight: 500;
          border-radius: 0.32rem;

          &.disabled {
            background: #f0f3f5 !important;
            color: #bcc4cc !important;
          }

          &.to-accept {
            background: #ffe888;
            color: #000;
          }

          &.doing {
            background-color: #fff;
            color: #fb750f;
            border: 0.01rem solid #ff8000;
          }

          &.can-done {
            background: #fe852a;
            color: #fff;
          }

          &.done {
            background: #ffe888;
            opacity: 0.5;
          }
        }
      }
    }
  }

  .tasks-line {
    width: 3.23rem;
    height: 0.01rem;
    margin: 0 auto;
    background-color: #f0f3f5;
    transform: scaleY(0.5);
  }
}
</style>
